import { QuestionarioEvento, RecapVM } from 'civil-status/view-models/step-form';

export const transformerQuestionario = (
  data: Array<RecapVM>,
  idEvento?: number
): Array<QuestionarioEvento> => {
  return data.map((item, index) => {
    return {
      key: {
        idEvento,
        numProgressivoStep: index + 1,
      },
      cdStepSuccessivo:
        item.responseData?.key?.codStepSuccessivo || item.codStepSuccessivo || undefined,
      codStep: item.responseData?.key?.codStep || item.step || undefined,
      idRisposta: item.responseData?.key?.idRisposta || item.codResponse || undefined,
      descBreveDomanda:
        item.responseData?.domandaQuestionarioVO?.descrizioneBreve || item.request || undefined,
      testoDomanda: item.responseData?.domandaQuestionarioVO?.testoDomanda || undefined,
      descBreveRisposta:
        item.responseData?.rispostaQuestionarioVO?.descrizioneBreve || item.response || undefined,
      testoRisposta: item.responseData?.rispostaQuestionarioVO?.testoRisposta || undefined,
    } as QuestionarioEvento;
  });
};
